<template>
<div class="px-4 sm:px-8 lg:px-0 bg-base md:bg-transparent">
    <div class="mx-auto my-12 w-full max-w-[640px] md:max-w-[1136px] bg-white rounded-lg shadow-md md:shadow-none px-4 sm:px-8 py-12 text-main">
        <div class="flex flex-col items-center gap-4 text-center pb-8">
            <h1 class="font-bold text-2xl leading-8">ECHOESアカウントを作成しました</h1>
            <div class="text-sm leading-5">
                <p>記事を作成・配信するには、YouTubeチャンネルの申請が必要です。</p>
                <p>YouTubeチャンネルオーナーの方は、チャンネルの申請へ進んでください。</p>
            </div>
            <p class="text-sm leading-5">
                登録済みのチャンネルに編集者として参加される方は、オーナーからの招待をお待ちください。
            </p>
        </div>

        <div class="flex flex-col md:flex-row gap-2 md:gap-4 justify-center">
            <button
                type="button"
                class="btn-lg btn-primary text-white px-4 md:w-auto"
                @click="goToApplication"
            >
                チャンネルを申請する
            </button>
            <button
                type="button"
                class="btn-lg bg-white border border-placeholder text-main px-4 md:w-auto"
                @click="waitForInvitation"
            >
                招待を待つ
            </button>
        </div>
    </div>
</div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const router = useRouter();
const store = useStore();

// #301: 「チャンネルを申請する」→ 申請フォーム画面へ遷移
const goToApplication = () => {
    router.push({ name: 'ChannelApplicationForm' });
};

// #301: 「招待を待つ」→ storeにフラグを立てて待機画面へ
// ChannelApplicationレコードが未作成の状態なのでAPIは呼ばない
const waitForInvitation = () => {
    store.commit('setWaitForInvitation', true);
    router.push({ name: 'ChannelApplicationWaiting' });
};
</script>
